import get from 'lodash/get';
import { compareStrings, compareNumbers } from '@/utils/utils';
import { isDecimal } from '@/utils/decimal';

export type sortGetter<Item> = string | ((item: Item, direction: string) => string | number)

export interface IColumnSortOptions<Item> {
  enabled?: boolean; // defaults to true
  sortGetter?: sortGetter<Item>;
  sortName?: string;
}

export interface ISortOptions {
  enabled?: boolean; // defaults to false
  remoteSorting?: boolean;
  initialSortName?: string;
  initialSortDirection?: 'asc' | 'desc';
}

function sortValue<Item>(item: Item, sortGetter: sortGetter<Item>, direction: string): string | number {
  return typeof sortGetter === 'function'
    ? sortGetter(item, direction)
    : get(item, sortGetter);
}

export function sort<Item>(data: Item[], sortGetter: sortGetter<Item>, direction: string) {
  return data.sort((current: Item, next: Item) => {
    const [ first, second ] = [
      sortValue(current, sortGetter, direction),
      sortValue(next, sortGetter, direction),
    ];
    let sorted = 0;
    if (typeof first === 'string' && typeof second === 'string') {
      sorted = compareStrings(first, second);
    } else if (typeof first === 'number' && typeof second === 'number') {
      sorted = compareNumbers(first, second);
    } else if (isDecimal(first) && isDecimal(second)) {
      sorted = compareNumbers(first.toNumber(), second.toNumber());
    } else {
      sorted = compareStrings(String(first), String(second));
    }
    return direction === 'asc' ? sorted : sorted * -1;
  });
}
